import { toast } from 'react-toastify';
import { useEffect } from 'react';

interface LoadingToastProps {
  message: string;
  isLoading: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
  successMessage?: string;
  toastId?: string;
}

export function LoadingToast({
  message,
  isLoading,
  isSuccess,
  isError,
  errorMessage,
  successMessage,
  toastId = 'loading-toast',
}: LoadingToastProps) {
  useEffect(() => {
    if (isLoading) {
      toast(message, {
        type: 'info',
        isLoading: true,
        autoClose: false,
        toastId,
      });
    } else if (isSuccess) {
      toast.dismiss(toastId);
      toast(successMessage || 'Success!', {
        type: 'success',
        isLoading: false,
        autoClose: 3000,
        toastId,
      });
    } else if (isError) {
      toast.dismiss(toastId);
      toast(errorMessage || 'An error occurred', {
        type: 'error',
        isLoading: false,
        autoClose: 3000,
        toastId,
      });
    }
  }, [
    isLoading,
    isSuccess,
    isError,
    message,
    successMessage,
    errorMessage,
    toastId,
  ]);

  return null;
}
